// extracted by mini-css-extract-plugin
export var button = "_lg-2";
export var card = "_lg-0";
export var closeButtonContainer = "_lg-3";
export var iconContainer = "_lg-1";